import { getProyectos, createProyecto, updateProyecto, deleteProyecto } from '../models/proyectoModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from 'svelte-toasts';

// Validar fechas
function validarFechas(proyecto) {
  const { fecha_inicio, fecha_cierre } = proyecto;
  if (new Date(fecha_cierre) < new Date(fecha_inicio)) {
    throw new Error('La fecha de cierre no puede ser menor que la fecha de inicio.');
  }
}

export async function fetchProyectos(page, perPage) {
  try {
    const response = await getProyectos(page, perPage);
    return {
      proyecto: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error('Error fetching proyectos:', error);
    Swal.fire('Error', 'No se pudieron cargar los proyectos', 'error');
    return null;
  }
}

export async function saveProyecto(proyecto, currentProyectoId) {
  try {
    // Validar las fechas antes de guardar
    validarFechas(proyecto);

    if (currentProyectoId) {
      await updateProyecto(currentProyectoId, proyecto);
      toasts.add({
        title: 'Éxito',
        description: 'Proyecto actualizado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    } else {
      await createProyecto(proyecto);
      toasts.add({
        title: 'Éxito',
        description: 'Proyecto creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    }
  } catch (error) {
    if (error.message === 'La fecha de cierre no puede ser menor que la fecha de inicio.') {
      Swal.fire('Error', error.message, 'error');
    } else {
      console.error('Error saving proyecto:', error);
      toasts.add({
        title: 'Error',
        description: 'Ocurrió un error al guardar el proyecto',
        duration: 3000,
        placement: 'bottom-right',
        type: 'error',
        theme: 'dark',
        showProgress: true,
      });
    }
  }
}

export async function removeProyecto(id) {
  try {
    await deleteProyecto(id);
    toasts.add({
      title: 'Éxito',
      description: 'Proyecto eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'success',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error('Error deleting proyecto:', error);
    Swal.fire('Error', 'No se pudo eliminar el proyecto', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'proyecto'
export function subscribeToProyectos(searchQuery, handleSearch) {
  pb.collection('proyecto').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromProyectos() {
  pb.collection('proyecto').unsubscribe('*');
}

export async function searchProyectos(query, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('proyecto').getList(page, perPage, {
      filter: `descripcion ~ "${query}"`, // Búsqueda por el campo 'descripcion'
    });
    return {
      proyecto: response.items,
      totalRecords: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error('Error searching proyectos:', error);
    Swal.fire('Error', 'No se pudieron buscar los proyectos', 'error');
    return null;
  }
}
